import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
} from "mdbreact";
import axios from "axios";
import MetaTags from "react-meta-tags";
import packkagee from "../../../package.json";

export default class Insertpresent4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      REGISTER_ID: null,
      FATHER_ADDRESS: null,
      ADDRESS_DISTRICT: null,
      FATHER_FRISTNAME_PARENT: null,
      FATHER_MIDNAME_PARENT: null,
      FATHER_LASTNAME_PARENT: null,
      FATHER_OCCUP_PARENT: null,
      FATHER_OCCUP_NAME_PARENT: null,
      FATHER_TELMOBILE_PARENT: null,
      ADDRESS_PROVINCY: null,
      FATHER_REVENUE_PARENT: null,
      PARENT_OTHER_PARENT: null,
      SUBDISTRICT: null,
      ADDRESS_SUBDISTRICT: null,
      FATHER_ADDRESS_ZIPCODE: null,
      FATHER_EMAIL_PARENT: null,
      MOTHER_ADDRESS: null,
      ADDRESS_DISTRICT1: null,
      MOTHER_FRISTNAME_PARENT: null,
      MOTHER_MIDNAME_PARENT: null,
      MOTHER_LASTNAME_PARENT: null,
      MOTHER_OCCUP_PARENT: null,
      MOTHER_OCCUP_NAME_PARENT: null,
      MOTHER_TELMOBILE_PARENT: null,
      MOTHER_EMAIL_PARENT: null,
      ADDRESS_PROVINCY1: null,
      MOTHER_REVENUE_PARENT: null,
      SUBDISTRICT1: null,
      ADDRESS_SUBDISTRICT1: null,
      MOTHER_ADDRESS_ZIPCODE: null,
      PARENT_ADDRESS: null,
      ADDRESS_DISTRICT2: null,
      PARENT_FRISTNAME_PARENT: null,
      PARENT_MIDNAME_PARENT: null,
      PARENT_LASTNAME_PARENT: null,
      PARENT_OCCUP_PARENT: null,
      PARENT_OCCUP_NAME_PARENT: null,
      PARENT_TELMOBILE_PARENT: null,
      ADDRESS_PROVINCY2: null,
      PARENT_REVENUE_PARENT: null,
      STATUS_PARENT: null,
      SUBDISTRICT2: null,
      ADDRESS_SUBDISTRICT2: null,
      PARENT_ADDRESS_ZIPCODE: null,
      FATHER_STATUS_PARENT: "1",
      MOTHER_STATUS_PARENT: "1",
      PARENT_STATUS_PARENT: "1",
      PARENTSTATUS: "3",
      FATHER_ADDRESS_HOME: null,
      FATHER_ADDRESS_MOO: null,
      FATHER_ADDRESS_SOI: null,
      FATHER_ADDRESS_STREET: null,
      FATHER_CITIZENT_PARENT: null,
      FATHER_PREFIX_PARENT: null,
      MOTHER_ADDRESS_HOME: null,
      MOTHER_ADDRESS_MOO: null,
      MOTHER_ADDRESS_SOI: null,
      MOTHER_ADDRESS_STREET: null,
      MOTHER_CITIZENT_PARENT: null,
      MOTHER_PREFIX_PARENT: null,
      PARENT_ADDRESS_HOME: null,
      PARENT_ADDRESS_MOO: null,
      PARENT_ADDRESS_SOI: null,
      PARENT_ADDRESS_STREET: null,
      PARENT_CITIZENT_PARENT: null,
      PARENT_EMAIL: null,
      PARENT_PREFIX_PARENT: null,
      FATHER_FACEBOOK: null,
      MOTHER_FACEBOOK: null,
      PARENT_FACEBOOK: null,

      array_prefix: [],
      array_parentshow: [],
      array_occup: [],
      array_revenue: [],
      array_province: [],
      array_district: [],
      array_district1: [],
      array_district2: [],
      array_sub_district: [],
      array_sub_district1: [],
      array_sub_district2: [],
    };
    this.handleProvinceChange = this.handleProvinceChange.bind(this);
    this.handleProvince1Change = this.handleProvince1Change.bind(this);
    this.handleProvince2Change = this.handleProvince2Change.bind(this);
    this.handleDistrictChange = this.handleDistrictChange.bind(this);
    this.handleDistrict1Change = this.handleDistrict1Change.bind(this);
    this.handleDistrict2Change = this.handleDistrict2Change.bind(this);
    this.handleSubDistrictChange = this.handleSubDistrictChange.bind(this);
    this.handleSubDistrict1Change = this.handleSubDistrict1Change.bind(this);
    this.handleSubDistrict2Change = this.handleSubDistrict2Change.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // axios.get("https://git.kpru.ac.th/admission2017/student/loadpresent/" + localStorage.getItem("ID_LOGIN")).then((respone) => {
    axios
      .get(
        "https://admission.kpru.ac.th/admission2017/student/loadpresent/" +
          localStorage.getItem("ID_LOGIN")
      )
      .then((respone) => {
        respone.data = respone.data.filter(({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11"));
        this.setState({ REGISTER_ID: respone.data[0]["REGISTER_ID"] });
        // axios.get("https://git.kpru.ac.th/admission2017/student_insertpresent4/profileparent/"+respone.data[0]["REGISTER_ID"]).then((parent) => {
        axios
          .get(
            "https://admission.kpru.ac.th/admission2017/student_insertpresent4/profileparent/" +
              respone.data[0]["REGISTER_ID"]
          )
          .then((parent) => {
            if (parent.data.length !== 0) {
              console.log(parent.data);
              if (parent.data[0]["STATUS_FATHER"] === "1") {
                let headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" });
                axios
                  .post(
                    "https://mua.kpru.ac.th/FrontEnd_Admission/admission/district_register/",
                    { provincy_study: parent.data[0]["FAT_PROVINCE"] },
                    { headers: headers }
                  )
                  .then((district) => {
                    this.setState({ array_district: district.data });
                  });
                axios
                  .post(
                    "https://mua.kpru.ac.th/FrontEnd_Admission/admission/subdistrict_register/",
                    { district_study: parent.data[0]["FAT_AMPHUR"] },
                    { headers: headers }
                  )
                  .then((sub_district) => {
                    this.setState({ array_sub_district: sub_district.data });
                  });
              }
              if (parent.data[0]["STATUS_MOTHER"] === "1") {
                let headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" });
                axios
                  .post(
                    "https://mua.kpru.ac.th/FrontEnd_Admission/admission/district_register/",
                    { provincy_study: parent.data[0]["MOT_PROVINCE"] },
                    { headers: headers }
                  )
                  .then((district) => {
                    this.setState({ array_district1: district.data });
                  });
                axios
                  .post(
                    "https://mua.kpru.ac.th/FrontEnd_Admission/admission/subdistrict_register/",
                    { district_study: parent.data[0]["MOT_AMPHUR"] },
                    { headers: headers }
                  )
                  .then((sub_district) => {
                    this.setState({ array_sub_district1: sub_district.data });
                  });
              }
              if (parent.data[0]["STATUS_PAR"] === "1") {
                let headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" });
                axios
                  .post(
                    "https://mua.kpru.ac.th/FrontEnd_Admission/admission/district_register/",
                    { provincy_study: parent.data[0]["PAR_PROVINCE"] },
                    { headers: headers }
                  )
                  .then((district) => {
                    this.setState({ array_district2: district.data });
                  });
                axios
                  .post(
                    "https://mua.kpru.ac.th/FrontEnd_Admission/admission/subdistrict_register/",
                    { district_study: parent.data[0]["PAR_AMPHUR"] },
                    { headers: headers }
                  )
                  .then((sub_district) => {
                    this.setState({ array_sub_district2: sub_district.data });
                  });
              }
              this.setState({ FATHER_STATUS_PARENT: parent.data[0]["STATUS_FATHER"] });
              this.setState({ FATHER_CITIZENT_PARENT: parent.data[0]["FAT_CITIZENT"] });
              this.setState({ FATHER_PREFIX_PARENT: parent.data[0]["FAT_PREFIX"] });
              this.setState({ FATHER_FRISTNAME_PARENT: parent.data[0]["FAT_FNAME"] });
              this.setState({ FATHER_MIDNAME_PARENT: parent.data[0]["FAT_MNAME"] });
              this.setState({ FATHER_LASTNAME_PARENT: parent.data[0]["FAT_LNAME"] });
              this.setState({ FATHER_TELMOBILE_PARENT: parent.data[0]["FAT_PHONE"] });
              this.setState({ FATHER_OCCUP_PARENT: parent.data[0]["FAT_OCCUP_ID"] });
              this.setState({ FATHER_OCCUP_NAME_PARENT: parent.data[0]["FAT_OCCUP_NAME"] });
              this.setState({ FATHER_REVENUE_PARENT: parent.data[0]["FAT_REVENUE_ID"] });
              this.setState({ FATHER_ADDRESS: parent.data[0]["FAT_ADDRESS"] });
              this.setState({ FATHER_ADDRESS_HOME: parent.data[0]["FAT_HOME"] });
              this.setState({ FATHER_ADDRESS_MOO: parent.data[0]["FAT_MOO"] });
              this.setState({ FATHER_ADDRESS_SOI: parent.data[0]["FAT_SOI"] });
              this.setState({ FATHER_ADDRESS_STREET: parent.data[0]["FAT_STREET"] });
              this.setState({ FATHER_FACEBOOK: parent.data[0]["FATHER_FACEBOOK"] });
              this.setState({ MOTHER_FACEBOOK: parent.data[0]["MOTHER_FACEBOOK"] });
              this.setState({ PARENT_FACEBOOK: parent.data[0]["PARENT_FACEBOOK"] });
              this.setState({ PARENT_OTHER_PARENT: parent.data[0]["PARENT_OTHER_PARENT"] });
              this.setState({
                SUBDISTRICT: parent.data[0]["FAT_TUMBON"] + "," + parent.data[0]["FAT_ZIPCODE"],
              });
              this.setState({ ADDRESS_SUBDISTRICT: parent.data[0]["FAT_TUMBON"] });
              this.setState({ ADDRESS_DISTRICT: parent.data[0]["FAT_AMPHUR"] });
              this.setState({ ADDRESS_PROVINCY: parent.data[0]["FAT_PROVINCE"] });
              this.setState({ FATHER_ADDRESS_ZIPCODE: parent.data[0]["FAT_ZIPCODE"] });

              this.setState({ MOTHER_STATUS_PARENT: parent.data[0]["STATUS_MOTHER"] });
              this.setState({ MOTHER_CITIZENT_PARENT: parent.data[0]["MOT_CITIZENT"] });
              this.setState({ MOTHER_PREFIX_PARENT: parent.data[0]["MOT_PREFIX"] });
              this.setState({ MOTHER_FRISTNAME_PARENT: parent.data[0]["MOT_FNAME"] });
              this.setState({ MOTHER_MIDNAME_PARENT: parent.data[0]["MOT_MNAME"] });
              this.setState({ MOTHER_LASTNAME_PARENT: parent.data[0]["MOT_LNAME"] });
              this.setState({ MOTHER_TELMOBILE_PARENT: parent.data[0]["MOT_PHONE"] });
              this.setState({ MOTHER_OCCUP_PARENT: parent.data[0]["MOT_OCCUP_ID"] });
              this.setState({ MOTHER_OCCUP_NAME_PARENT: parent.data[0]["MOT_OCCUP_NAME"] });
              this.setState({ MOTHER_REVENUE_PARENT: parent.data[0]["MOT_REVENUE_ID"] });
              this.setState({ MOTHER_ADDRESS: parent.data[0]["MOT_ADDRESS"] });
              this.setState({ MOTHER_ADDRESS_HOME: parent.data[0]["MOT_HOME"] });
              this.setState({ MOTHER_ADDRESS_MOO: parent.data[0]["MOT_MOO"] });
              this.setState({ MOTHER_ADDRESS_SOI: parent.data[0]["MOT_SOI"] });
              this.setState({ MOTHER_ADDRESS_STREET: parent.data[0]["MOT_STREET"] });
              this.setState({
                SUBDISTRICT1: parent.data[0]["MOT_TUMBOL"] + "," + parent.data[0]["MOT_ZIPCODE"],
              });
              this.setState({ ADDRESS_SUBDISTRICT1: parent.data[0]["MOT_TUMBOL"] });
              this.setState({ ADDRESS_DISTRICT1: parent.data[0]["MOT_AMPHUR"] });
              this.setState({ ADDRESS_PROVINCY1: parent.data[0]["MOT_PROVINCE"] });
              this.setState({ MOTHER_ADDRESS_ZIPCODE: parent.data[0]["MOT_ZIPCODE"] });
              this.setState({ STATUS_PARENT: parent.data[0]["PAR_STATUS_ID"] });

              if (parent.data[0]["FAT_FNAME"] === parent.data[0]["PAR_FNAME"]) {
                this.setState({ PARENTSTATUS: "1" });
              } else if (parent.data[0]["MOT_FNAME"] === parent.data[0]["PAR_FNAME"]) {
                this.setState({ PARENTSTATUS: "2" });
              } else {
                this.setState({ PARENTSTATUS: "3" });
              }

              this.setState({ PARENT_STATUS_PARENT: parent.data[0]["STATUS_PAR"] });
              this.setState({ PARENT_CITIZENT_PARENT: parent.data[0]["PAR_CITIZENT"] });
              this.setState({ PARENT_PREFIX_PARENT: parent.data[0]["PAR_PREFIX"] });
              this.setState({ PARENT_FRISTNAME_PARENT: parent.data[0]["PAR_FNAME"] });
              this.setState({ PARENT_MIDNAME_PARENT: parent.data[0]["PAR_MNAME"] });
              this.setState({ PARENT_LASTNAME_PARENT: parent.data[0]["PAR_LNAME"] });
              this.setState({ PARENT_TELMOBILE_PARENT: parent.data[0]["PAR_PHONE"] });
              this.setState({ PARENT_OCCUP_PARENT: parent.data[0]["PAR_OCCUP_ID"] });
              this.setState({ PARENT_OCCUP_NAME_PARENT: parent.data[0]["PAR_OCCUP_NAME"] });
              this.setState({ PARENT_REVENUE_PARENT: parent.data[0]["PAR_REVENUE_ID"] });
              this.setState({ PARENT_ADDRESS: parent.data[0]["PAR_ADDRESS"] });
              this.setState({ PARENT_ADDRESS_HOME: parent.data[0]["PAR_HOME"] });
              this.setState({ PARENT_ADDRESS_MOO: parent.data[0]["PAR_MOO"] });
              this.setState({ PARENT_ADDRESS_SOI: parent.data[0]["PAR_SOI"] });
              this.setState({ PARENT_ADDRESS_STREET: parent.data[0]["PAR_STREET"] });
              this.setState({
                SUBDISTRICT2: parent.data[0]["PAR_TUMBON"] + "," + parent.data[0]["PAR_ZIPCODE"],
              });
              this.setState({ ADDRESS_SUBDISTRICT2: parent.data[0]["PAR_TUMBON"] });
              this.setState({ ADDRESS_DISTRICT2: parent.data[0]["PAR_AMPHUR"] });
              this.setState({ ADDRESS_PROVINCY2: parent.data[0]["PAR_PROVINCE"] });
              this.setState({ PARENT_ADDRESS_ZIPCODE: parent.data[0]["PAR_ZIPCODE"] });
            }
          });
      });
    axios
      .get("https://mua.kpru.ac.th/FrontEnd_Admission/admission/province_register/")
      .then((province) => {
        this.setState({ array_province: province.data });
      });
    axios.get("https://admission.kpru.ac.th/admission2017/login/prefix").then((prefix) => {
      this.setState({ array_prefix: prefix.data });
    });
    axios.get("https://admission.kpru.ac.th/admission2017/dashboard_parent/occup").then((occup) => {
      console.log(occup.data);
      this.setState({ array_occup: occup.data });
    });
    axios
      .get("https://admission.kpru.ac.th/admission2017/dashboard_parent/revenue")
      .then((revenue) => {
        // กรณีดึงบางส่วน
        const revenued = revenue.data.filter(
          ({ REVENUE_ID }) =>
            !(
              REVENUE_ID === "11" ||
              REVENUE_ID === "12" ||
              REVENUE_ID === "13" ||
              REVENUE_ID === "14" ||
              REVENUE_ID === "15" ||
              REVENUE_ID === "20" ||
              REVENUE_ID === "30"
            )
        );
        this.setState({ array_revenue: revenued });

        // กรณีดึงรายได้ทั้งหมด
        // this.setState({ array_revenue: revenue.data });
      });
    axios
      .get("https://admission.kpru.ac.th/admission2017/dashboard_parent/parentshow")
      .then((parentshow) => {
        this.setState({ array_parentshow: parentshow.data });
      });
  }

  handleProvinceChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" });
    axios
      .post(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admission/district_register/",
        { provincy_study: event.target.value },
        { headers: headers }
      )
      .then((district) => {
        this.setState({ array_district: district.data });
      });
  }

  handleDistrictChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" });
    axios
      .post(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admission/subdistrict_register/",
        { district_study: event.target.value },
        { headers: headers }
      )
      .then((sub_district) => {
        this.setState({ array_sub_district: sub_district.data });
      });
  }

  handleSubDistrictChange(event) {
    var spitsubdistrict = event.target.value.split(",");
    if (spitsubdistrict !== "") {
      this.setState({ [event.target.name]: event.target.value });
      this.setState({ ["ADDRESS_" + event.target.name]: spitsubdistrict[0] });
      this.setState({ FATHER_ADDRESS_ZIPCODE: spitsubdistrict[1] });
    }
  }

  handleProvince1Change(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" });
    axios
      .post(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admission/district_register/",
        { provincy_study: event.target.value },
        { headers: headers }
      )
      .then((district1) => {
        this.setState({ array_district1: district1.data });
      });
  }

  handleDistrict1Change(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" });
    axios
      .post(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admission/subdistrict_register/",
        { district_study: event.target.value },
        { headers: headers }
      )
      .then((sub_district1) => {
        this.setState({ array_sub_district1: sub_district1.data });
      });
  }

  handleSubDistrict1Change(event) {
    var spitsubdistrict = event.target.value.split(",");
    if (spitsubdistrict !== "") {
      this.setState({ [event.target.name]: event.target.value });
      this.setState({ ["ADDRESS_" + event.target.name]: spitsubdistrict[0] });
      this.setState({ MOTHER_ADDRESS_ZIPCODE: spitsubdistrict[1] });
    }
  }

  handleProvince2Change(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" });
    axios
      .post(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admission/district_register/",
        { provincy_study: event.target.value },
        { headers: headers }
      )
      .then((district2) => {
        this.setState({ array_district2: district2.data });
      });
  }

  handleDistrict2Change(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({ "Content-Type": "application/x-www-form-urlencoded" });
    axios
      .post(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admission/subdistrict_register/",
        { district_study: event.target.value },
        { headers: headers }
      )
      .then((sub_district2) => {
        this.setState({ array_sub_district2: sub_district2.data });
      });
  }

  handleSubDistrict2Change(event) {
    var spitsubdistrict = event.target.value.split(",");
    if (spitsubdistrict !== "") {
      this.setState({ [event.target.name]: event.target.value });
      this.setState({ ["ADDRESS_" + event.target.name]: spitsubdistrict[0] });
      this.setState({ PARENT_ADDRESS_ZIPCODE: spitsubdistrict[1] });
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleClick(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    let bodydata = {};
    if (this.state.PARENTSTATUS === "1") {
      bodydata = {
        REGISTER_ID: this.state.REGISTER_ID,
        PARENT_OTHER_PARENT: 'บิดา',
        FATHER_ADDRESS: this.state.FATHER_ADDRESS,
        ADDRESS_DISTRICT: this.state.ADDRESS_DISTRICT,
        FATHER_FRISTNAME_PARENT: this.state.FATHER_FRISTNAME_PARENT,
        FATHER_MIDNAME_PARENT: this.state.FATHER_MIDNAME_PARENT,
        FATHER_LASTNAME_PARENT: this.state.FATHER_LASTNAME_PARENT,
        FATHER_OCCUP_PARENT: this.state.FATHER_OCCUP_PARENT,
        FATHER_OCCUP_NAME_PARENT: this.state.FATHER_OCCUP_NAME_PARENT,
        FATHER_TELMOBILE_PARENT: this.state.FATHER_TELMOBILE_PARENT,
        ADDRESS_PROVINCY: this.state.ADDRESS_PROVINCY,
        FATHER_REVENUE_PARENT: this.state.FATHER_REVENUE_PARENT,
        ADDRESS_SUBDISTRICT: this.state.ADDRESS_SUBDISTRICT,
        FATHER_ADDRESS_ZIPCODE: this.state.FATHER_ADDRESS_ZIPCODE,
        FATHER_EMAIL_PARENT: this.state.FATHER_EMAIL_PARENT,
        MOTHER_ADDRESS: this.state.MOTHER_ADDRESS,
        ADDRESS_DISTRICT1: this.state.ADDRESS_DISTRICT1,
        MOTHER_FRISTNAME_PARENT: this.state.MOTHER_FRISTNAME_PARENT,
        MOTHER_MIDNAME_PARENT: this.state.MOTHER_MIDNAME_PARENT,
        MOTHER_LASTNAME_PARENT: this.state.MOTHER_LASTNAME_PARENT,
        MOTHER_OCCUP_PARENT: this.state.MOTHER_OCCUP_PARENT,
        MOTHER_OCCUP_NAME_PARENT: this.state.MOTHER_OCCUP_NAME_PARENT,
        MOTHER_TELMOBILE_PARENT: this.state.MOTHER_TELMOBILE_PARENT,
        MOTHER_EMAIL_PARENT: this.state.MOTHER_EMAIL_PARENT,
        ADDRESS_PROVINCY1: this.state.ADDRESS_PROVINCY1,
        MOTHER_REVENUE_PARENT: this.state.MOTHER_REVENUE_PARENT,
        ADDRESS_SUBDISTRICT1: this.state.ADDRESS_SUBDISTRICT1,
        MOTHER_ADDRESS_ZIPCODE: this.state.MOTHER_ADDRESS_ZIPCODE,
        PARENT_ADDRESS: this.state.FATHER_ADDRESS,
        PARENT_FACEBOOK: this.state.FATHER_FACEBOOK,
        FATHER_FACEBOOK: this.state.FATHER_FACEBOOK,
        MOTHER_FACEBOOK: this.state.MOTHER_FACEBOOK,
        ADDRESS_DISTRICT2: this.state.ADDRESS_DISTRICT,
        PARENT_FRISTNAME_PARENT: this.state.FATHER_FRISTNAME_PARENT,
        PARENT_MIDNAME_PARENT: this.state.FATHER_MIDNAME_PARENT,
        PARENT_LASTNAME_PARENT: this.state.FATHER_LASTNAME_PARENT,
        PARENT_OCCUP_PARENT: this.state.FATHER_OCCUP_PARENT,
        PARENT_OCCUP_NAME_PARENT: this.state.FATHER_OCCUP_NAME_PARENT,
        PARENT_TELMOBILE_PARENT: this.state.FATHER_TELMOBILE_PARENT,
        ADDRESS_PROVINCY2: this.state.ADDRESS_PROVINCY,
        PARENT_REVENUE_PARENT: this.state.FATHER_REVENUE_PARENT,
        STATUS_PARENT: this.state.STATUS_PARENT,
        ADDRESS_SUBDISTRICT2: this.state.ADDRESS_SUBDISTRICT,
        PARENT_ADDRESS_ZIPCODE: this.state.FATHER_ADDRESS_ZIPCODE,
        FATHER_STATUS_PARENT: this.state.FATHER_STATUS_PARENT,
        MOTHER_STATUS_PARENT: this.state.MOTHER_STATUS_PARENT,
        PARENT_STATUS_PARENT: this.state.PARENT_STATUS_PARENT,
        FATHER_ADDRESS_HOME: this.state.FATHER_ADDRESS_HOME,
        FATHER_ADDRESS_MOO: this.state.FATHER_ADDRESS_MOO,
        FATHER_ADDRESS_SOI: this.state.FATHER_ADDRESS_SOI,
        FATHER_ADDRESS_STREET: this.state.FATHER_ADDRESS_STREET,
        FATHER_CITIZENT_PARENT: this.state.FATHER_CITIZENT_PARENT,
        FATHER_PREFIX_PARENT: this.state.FATHER_PREFIX_PARENT,
        MOTHER_ADDRESS_HOME: this.state.MOTHER_ADDRESS_HOME,
        MOTHER_ADDRESS_MOO: this.state.MOTHER_ADDRESS_MOO,
        MOTHER_ADDRESS_SOI: this.state.MOTHER_ADDRESS_SOI,
        MOTHER_ADDRESS_STREET: this.state.MOTHER_ADDRESS_STREET,
        MOTHER_CITIZENT_PARENT: this.state.MOTHER_CITIZENT_PARENT,
        MOTHER_PREFIX_PARENT: this.state.MOTHER_PREFIX_PARENT,
        PARENT_ADDRESS_HOME: this.state.FATHER_ADDRESS_HOME,
        PARENT_ADDRESS_MOO: this.state.FATHER_ADDRESS_MOO,
        PARENT_ADDRESS_SOI: this.state.FATHER_ADDRESS_SOI,
        PARENT_ADDRESS_STREET: this.state.FATHER_ADDRESS_STREET,
        PARENT_CITIZENT_PARENT: this.state.FATHER_CITIZENT_PARENT,
        PARENT_EMAIL: this.state.FATHER_EMAIL_PARENT,
        PARENT_PREFIX_PARENT: this.state.FATHER_PREFIX_PARENT,
      };
    } else if (this.state.PARENTSTATUS === "2") {
      bodydata = {
        REGISTER_ID: this.state.REGISTER_ID,
        PARENT_OTHER_PARENT: 'มารดา',

        FATHER_ADDRESS: this.state.FATHER_ADDRESS,
        ADDRESS_DISTRICT: this.state.ADDRESS_DISTRICT,
        FATHER_FRISTNAME_PARENT: this.state.FATHER_FRISTNAME_PARENT,
        FATHER_MIDNAME_PARENT: this.state.FATHER_MIDNAME_PARENT,
        FATHER_LASTNAME_PARENT: this.state.FATHER_LASTNAME_PARENT,
        FATHER_OCCUP_PARENT: this.state.FATHER_OCCUP_PARENT,
        FATHER_OCCUP_NAME_PARENT: this.state.FATHER_OCCUP_NAME_PARENT,
        FATHER_TELMOBILE_PARENT: this.state.FATHER_TELMOBILE_PARENT,
        ADDRESS_PROVINCY: this.state.ADDRESS_PROVINCY,
        FATHER_REVENUE_PARENT: this.state.FATHER_REVENUE_PARENT,
        ADDRESS_SUBDISTRICT: this.state.ADDRESS_SUBDISTRICT,
        FATHER_ADDRESS_ZIPCODE: this.state.FATHER_ADDRESS_ZIPCODE,
        FATHER_EMAIL_PARENT: this.state.FATHER_EMAIL_PARENT,
        MOTHER_ADDRESS: this.state.MOTHER_ADDRESS,
        ADDRESS_DISTRICT1: this.state.ADDRESS_DISTRICT1,
        MOTHER_FRISTNAME_PARENT: this.state.MOTHER_FRISTNAME_PARENT,
        MOTHER_MIDNAME_PARENT: this.state.MOTHER_MIDNAME_PARENT,
        MOTHER_LASTNAME_PARENT: this.state.MOTHER_LASTNAME_PARENT,
        MOTHER_OCCUP_PARENT: this.state.MOTHER_OCCUP_PARENT,
        MOTHER_OCCUP_NAME_PARENT: this.state.MOTHER_OCCUP_NAME_PARENT,
        MOTHER_TELMOBILE_PARENT: this.state.MOTHER_TELMOBILE_PARENT,
        MOTHER_EMAIL_PARENT: this.state.MOTHER_EMAIL_PARENT,
        ADDRESS_PROVINCY1: this.state.ADDRESS_PROVINCY1,
        MOTHER_REVENUE_PARENT: this.state.MOTHER_REVENUE_PARENT,
        ADDRESS_SUBDISTRICT1: this.state.ADDRESS_SUBDISTRICT1,
        MOTHER_ADDRESS_ZIPCODE: this.state.MOTHER_ADDRESS_ZIPCODE,
        PARENT_ADDRESS: this.state.MOTHER_ADDRESS,
        PARENT_FACEBOOK: this.state.MOTHER_FACEBOOK,
        FATHER_FACEBOOK: this.state.FATHER_FACEBOOK,
        MOTHER_FACEBOOK: this.state.MOTHER_FACEBOOK,
        ADDRESS_DISTRICT2: this.state.ADDRESS_DISTRICT1,
        PARENT_FRISTNAME_PARENT: this.state.MOTHER_FRISTNAME_PARENT,
        PARENT_MIDNAME_PARENT: this.state.MOTHER_MIDNAME_PARENT,
        PARENT_LASTNAME_PARENT: this.state.MOTHER_LASTNAME_PARENT,
        PARENT_OCCUP_PARENT: this.state.MOTHER_OCCUP_PARENT,
        PARENT_OCCUP_NAME_PARENT: this.state.MOTHER_OCCUP_NAME_PARENT,
        PARENT_TELMOBILE_PARENT: this.state.MOTHER_TELMOBILE_PARENT,
        ADDRESS_PROVINCY2: this.state.ADDRESS_PROVINCY1,
        PARENT_REVENUE_PARENT: this.state.MOTHER_REVENUE_PARENT,
        STATUS_PARENT: this.state.STATUS_PARENT,
        ADDRESS_SUBDISTRICT2: this.state.ADDRESS_SUBDISTRICT1,
        PARENT_ADDRESS_ZIPCODE: this.state.MOTHER_ADDRESS_ZIPCODE,
        FATHER_STATUS_PARENT: this.state.FATHER_STATUS_PARENT,
        MOTHER_STATUS_PARENT: this.state.MOTHER_STATUS_PARENT,
        PARENT_STATUS_PARENT: this.state.PARENT_STATUS_PARENT,
        FATHER_ADDRESS_HOME: this.state.FATHER_ADDRESS_HOME,
        FATHER_ADDRESS_MOO: this.state.FATHER_ADDRESS_MOO,
        FATHER_ADDRESS_SOI: this.state.FATHER_ADDRESS_SOI,
        FATHER_ADDRESS_STREET: this.state.FATHER_ADDRESS_STREET,
        FATHER_CITIZENT_PARENT: this.state.FATHER_CITIZENT_PARENT,
        FATHER_PREFIX_PARENT: this.state.FATHER_PREFIX_PARENT,
        MOTHER_ADDRESS_HOME: this.state.MOTHER_ADDRESS_HOME,
        MOTHER_ADDRESS_MOO: this.state.MOTHER_ADDRESS_MOO,
        MOTHER_ADDRESS_SOI: this.state.MOTHER_ADDRESS_SOI,
        MOTHER_ADDRESS_STREET: this.state.MOTHER_ADDRESS_STREET,
        MOTHER_CITIZENT_PARENT: this.state.MOTHER_CITIZENT_PARENT,
        MOTHER_PREFIX_PARENT: this.state.MOTHER_PREFIX_PARENT,
        PARENT_ADDRESS_HOME: this.state.MOTHER_ADDRESS_HOME,
        PARENT_ADDRESS_MOO: this.state.MOTHER_ADDRESS_MOO,
        PARENT_ADDRESS_SOI: this.state.MOTHER_ADDRESS_SOI,
        PARENT_ADDRESS_STREET: this.state.MOTHER_ADDRESS_STREET,
        PARENT_CITIZENT_PARENT: this.state.MOTHER_CITIZENT_PARENT,
        PARENT_EMAIL: this.state.MOTHER_EMAIL_PARENT,
        PARENT_PREFIX_PARENT: this.state.MOTHER_PREFIX_PARENT,
      };
    } else if (this.state.PARENTSTATUS === "3") {
      bodydata = {
        REGISTER_ID: this.state.REGISTER_ID,
        FATHER_ADDRESS: this.state.FATHER_ADDRESS,
        PARENT_OTHER_PARENT: this.state.PARENT_OTHER_PARENT,
        ADDRESS_DISTRICT: this.state.ADDRESS_DISTRICT,
        FATHER_FRISTNAME_PARENT: this.state.FATHER_FRISTNAME_PARENT,
        FATHER_MIDNAME_PARENT: this.state.FATHER_MIDNAME_PARENT,
        FATHER_LASTNAME_PARENT: this.state.FATHER_LASTNAME_PARENT,
        FATHER_OCCUP_PARENT: this.state.FATHER_OCCUP_PARENT,
        FATHER_OCCUP_NAME_PARENT: this.state.FATHER_OCCUP_NAME_PARENT,
        FATHER_TELMOBILE_PARENT: this.state.FATHER_TELMOBILE_PARENT,
        ADDRESS_PROVINCY: this.state.ADDRESS_PROVINCY,
        FATHER_REVENUE_PARENT: this.state.FATHER_REVENUE_PARENT,
        ADDRESS_SUBDISTRICT: this.state.ADDRESS_SUBDISTRICT,
        FATHER_ADDRESS_ZIPCODE: this.state.FATHER_ADDRESS_ZIPCODE,
        FATHER_EMAIL_PARENT: this.state.FATHER_EMAIL_PARENT,
        MOTHER_ADDRESS: this.state.MOTHER_ADDRESS,
        ADDRESS_DISTRICT1: this.state.ADDRESS_DISTRICT1,
        MOTHER_FRISTNAME_PARENT: this.state.MOTHER_FRISTNAME_PARENT,
        MOTHER_MIDNAME_PARENT: this.state.MOTHER_MIDNAME_PARENT,
        MOTHER_LASTNAME_PARENT: this.state.MOTHER_LASTNAME_PARENT,
        MOTHER_OCCUP_PARENT: this.state.MOTHER_OCCUP_PARENT,
        MOTHER_OCCUP_NAME_PARENT: this.state.MOTHER_OCCUP_NAME_PARENT,
        MOTHER_TELMOBILE_PARENT: this.state.MOTHER_TELMOBILE_PARENT,
        MOTHER_EMAIL_PARENT: this.state.MOTHER_EMAIL_PARENT,
        ADDRESS_PROVINCY1: this.state.ADDRESS_PROVINCY1,
        MOTHER_REVENUE_PARENT: this.state.MOTHER_REVENUE_PARENT,
        ADDRESS_SUBDISTRICT1: this.state.ADDRESS_SUBDISTRICT1,
        MOTHER_ADDRESS_ZIPCODE: this.state.MOTHER_ADDRESS_ZIPCODE,
        PARENT_ADDRESS: this.state.PARENT_ADDRESS,
        PARENT_FACEBOOK: this.state.PARENT_FACEBOOK,
        FATHER_FACEBOOK: this.state.FATHER_FACEBOOK,
        MOTHER_FACEBOOK: this.state.MOTHER_FACEBOOK,
        ADDRESS_DISTRICT2: this.state.ADDRESS_DISTRICT2,
        PARENT_FRISTNAME_PARENT: this.state.PARENT_FRISTNAME_PARENT,
        PARENT_MIDNAME_PARENT: this.state.PARENT_MIDNAME_PARENT,
        PARENT_LASTNAME_PARENT: this.state.PARENT_LASTNAME_PARENT,
        PARENT_OCCUP_PARENT: this.state.PARENT_OCCUP_PARENT,
        PARENT_OCCUP_NAME_PARENT: this.state.PARENT_OCCUP_NAME_PARENT,
        PARENT_TELMOBILE_PARENT: this.state.PARENT_TELMOBILE_PARENT,
        ADDRESS_PROVINCY2: this.state.ADDRESS_PROVINCY2,
        PARENT_REVENUE_PARENT: this.state.PARENT_REVENUE_PARENT,
        STATUS_PARENT: this.state.STATUS_PARENT,
        ADDRESS_SUBDISTRICT2: this.state.ADDRESS_SUBDISTRICT2,
        PARENT_ADDRESS_ZIPCODE: this.state.PARENT_ADDRESS_ZIPCODE,
        FATHER_STATUS_PARENT: this.state.FATHER_STATUS_PARENT,
        MOTHER_STATUS_PARENT: this.state.MOTHER_STATUS_PARENT,
        PARENT_STATUS_PARENT: this.state.PARENT_STATUS_PARENT,
        FATHER_ADDRESS_HOME: this.state.FATHER_ADDRESS_HOME,
        FATHER_ADDRESS_MOO: this.state.FATHER_ADDRESS_MOO,
        FATHER_ADDRESS_SOI: this.state.FATHER_ADDRESS_SOI,
        FATHER_ADDRESS_STREET: this.state.FATHER_ADDRESS_STREET,
        FATHER_CITIZENT_PARENT: this.state.FATHER_CITIZENT_PARENT,
        FATHER_PREFIX_PARENT: this.state.FATHER_PREFIX_PARENT,
        MOTHER_ADDRESS_HOME: this.state.MOTHER_ADDRESS_HOME,
        MOTHER_ADDRESS_MOO: this.state.MOTHER_ADDRESS_MOO,
        MOTHER_ADDRESS_SOI: this.state.MOTHER_ADDRESS_SOI,
        MOTHER_ADDRESS_STREET: this.state.MOTHER_ADDRESS_STREET,
        MOTHER_CITIZENT_PARENT: this.state.MOTHER_CITIZENT_PARENT,
        MOTHER_PREFIX_PARENT: this.state.MOTHER_PREFIX_PARENT,
        PARENT_ADDRESS_HOME: this.state.PARENT_ADDRESS_HOME,
        PARENT_ADDRESS_MOO: this.state.PARENT_ADDRESS_MOO,
        PARENT_ADDRESS_SOI: this.state.PARENT_ADDRESS_SOI,
        PARENT_ADDRESS_STREET: this.state.PARENT_ADDRESS_STREET,
        PARENT_CITIZENT_PARENT: this.state.PARENT_CITIZENT_PARENT,
        PARENT_EMAIL: this.state.PARENT_EMAIL,
        PARENT_PREFIX_PARENT: this.state.PARENT_PREFIX_PARENT,
      };
    }
    // axios.post("https://git.kpru.ac.th/admission2017/student_insertpresent4/updatepresent/"+this.state.REGISTER_ID, bodydata).then((data) => {
    axios
      .post(
        "https://admission.kpru.ac.th/admission2017/student_insertpresent4/updatepresent/" +
          this.state.REGISTER_ID,
        bodydata
      )
      .then((data) => {
        window.location.href = "/" + packkagee.name + "/Insertpresent5";
      });
  }

  render() {
    return (
      <>
        <MetaTags>
          <title>ข้อมูลผู้ปกครอง มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ข้อมูลผู้ปกครอง มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta property="og:title" content="ข้อมูลผู้ปกครอง มหาวิทยาลัยราชภัฏกำแพงเพชร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          <h4>ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
          <form onSubmit={this.handleSubmit}>
            <MDBRow>
              <MDBCol lg="1" md="0" sm="0"></MDBCol>
              <MDBCol lg="10" md="12" sm="12">
                <MDBCard>
                  <MDBCardBody>
                    <MDBContainer fluid>
                      <MDBRow>
                        <MDBCol>
                          <MDBCardText>
                            <span className="text-danger">* จำเป็นต้องกรอกข้อมูล</span>
                            <MDBCardTitle className="mt-2 black-text">ข้อมูลบิดา</MDBCardTitle>
                            <MDBRow className="mt-2">
                              <MDBCol lg="2" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="FATHER_STATUS_PARENT2">
                                    สถานภาพบิดา <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="FATHER_STATUS_PARENT"
                                      id="FATHER_STATUS_PARENT1"
                                      onClick={this.handleClick}
                                      value="0"
                                      checked={
                                        this.state.FATHER_STATUS_PARENT === "0" ? true : false
                                      }
                                    />
                                    <label className="form-check-label" for="FATHER_STATUS_PARENT1">
                                      ถึงแก่กรรม
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="FATHER_STATUS_PARENT"
                                      id="FATHER_STATUS_PARENT2"
                                      onClick={this.handleClick}
                                      value="1"
                                      checked={
                                        this.state.FATHER_STATUS_PARENT === "1" ? true : false
                                      }
                                    />
                                    <label className="form-check-label" for="FATHER_STATUS_PARENT2">
                                      มีชีวิต
                                    </label>
                                  </div>
                                </div>
                              </MDBCol>
                              {this.state.FATHER_STATUS_PARENT === "1" ? (
                                <>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_CITIZENT_PARENT">
                                        เลขบัตรประชาชนบิดา <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="FATHER_CITIZENT_PARENT"
                                        name="FATHER_CITIZENT_PARENT"
                                        onChange={this.handleChange}
                                        value={this.state.FATHER_CITIZENT_PARENT}
                                        maxLength="13"
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_PREFIX_PARENT">
                                        คำนำหน้าบิดา <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="FATHER_PREFIX_PARENT"
                                        name="FATHER_PREFIX_PARENT"
                                        value={this.state.FATHER_PREFIX_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุคำนำหน้าบิดา
                                        </option>
                                        {this.state.array_prefix.map((data) => {
                                          return data.PREFIX_NAME_ID ===
                                            this.state.FATHER_PREFIX_PARENT ? (
                                            <>
                                              <option value={data.PREFIX_NAME_ID} selected>
                                                {data.FULLNAME}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.PREFIX_NAME_ID}>
                                                {data.FULLNAME}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_FRISTNAME_PARENT">
                                        ชื่อภาษาไทยบิดา <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="FATHER_FRISTNAME_PARENT"
                                        name="FATHER_FRISTNAME_PARENT"
                                        value={this.state.FATHER_FRISTNAME_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_MIDNAME_PARENT">
                                        ชื่อกลางภาษาไทยบิดา
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="FATHER_MIDNAME_PARENT"
                                        name="FATHER_MIDNAME_PARENT"
                                        value={this.state.FATHER_MIDNAME_PARENT}
                                        onChange={this.handleChange}
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_LASTNAME_PARENT">
                                        นามสกุลภาษาไทยบิดา <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="FATHER_LASTNAME_PARENT"
                                        name="FATHER_LASTNAME_PARENT"
                                        value={this.state.FATHER_LASTNAME_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_TELMOBILE_PARENT">
                                        เบอร์โทรศัพท์มือถือบิดา{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="tel"
                                        className="form-control"
                                        id="FATHER_TELMOBILE_PARENT"
                                        name="FATHER_TELMOBILE_PARENT"
                                        value={this.state.FATHER_TELMOBILE_PARENT}
                                        onChange={this.handleChange}
                                        maxLength="10"
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_OCCUP_PARENT">
                                        อาชีพบิดา <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="FATHER_OCCUP_PARENT"
                                        name="FATHER_OCCUP_PARENT"
                                        value={this.state.FATHER_OCCUP_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุอาชีพบิดา
                                        </option>
                                        {this.state.array_occup.map((data) => {
                                          return data.OCCUP_ID ===
                                            this.state.FATHER_OCCUP_PARENT ? (
                                            <>
                                              <option value={data.OCCUP_ID} selected>
                                                {data.OCCUP_NAME}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.OCCUP_ID}>
                                                {data.OCCUP_NAME}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  {this.state.FATHER_OCCUP_PARENT === "07" ? (
                                    <>
                                      <MDBCol lg="3" md="4" sm="12">
                                        <div className="form-outline mt-2">
                                          <label
                                            className="form-label"
                                            for="FATHER_OCCUP_NAME_PARENT"
                                          >
                                            ระบุอาชีพบิดา
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="FATHER_OCCUP_NAME_PARENT"
                                            name="FATHER_OCCUP_NAME_PARENT"
                                            value={this.state.FATHER_OCCUP_NAME_PARENT}
                                            onChange={this.handleChange}
                                            required
                                          />
                                        </div>
                                      </MDBCol>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_REVENUE_PARENT">
                                        รายได้บิดา <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="FATHER_REVENUE_PARENT"
                                        name="FATHER_REVENUE_PARENT"
                                        value={this.state.FATHER_REVENUE_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุรายได้บิดา
                                        </option>
                                        {this.state.array_revenue.map((data) => {
                                          return data.REVENUE_ID ===
                                            this.state.FATHER_REVENUE_PARENT ? (
                                            <>
                                              <option value={data.REVENUE_ID} selected>
                                                {data.REVENUE_NAME}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.REVENUE_ID}>
                                                {data.REVENUE_NAME}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_FACEBOOK">
                                        Facebook <span className="text-danger"></span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="FATHER_FACEBOOK"
                                        name="FATHER_FACEBOOK"
                                        value={this.state.FATHER_FACEBOOK}
                                        onChange={this.handleChange}
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_ADDRESS">
                                        ชื่อหน่วยงาน/สถานทีทำงาน{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="FATHER_ADDRESS"
                                        name="FATHER_ADDRESS"
                                        value={this.state.FATHER_ADDRESS}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_ADDRESS_HOME">
                                        เลขที่ <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="FATHER_ADDRESS_HOME"
                                        name="FATHER_ADDRESS_HOME"
                                        value={this.state.FATHER_ADDRESS_HOME}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_ADDRESS_MOO">
                                        หมู่ที่ <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="FATHER_ADDRESS_MOO"
                                        name="FATHER_ADDRESS_MOO"
                                        value={this.state.FATHER_ADDRESS_MOO}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_ADDRESS_SOI">
                                        ซอย <span className="text-danger">หากไม่มีให้ใส่ -</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="FATHER_ADDRESS_SOI"
                                        name="FATHER_ADDRESS_SOI"
                                        value={this.state.FATHER_ADDRESS_SOI}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_ADDRESS_STREET">
                                        ถนน <span className="text-danger">หากไม่มีให้ใส่ -</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="FATHER_ADDRESS_STREET"
                                        name="FATHER_ADDRESS_STREET"
                                        value={this.state.FATHER_ADDRESS_STREET}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="ADDRESS_PROVINCY">
                                        จังหวัด <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="ADDRESS_PROVINCY"
                                        name="ADDRESS_PROVINCY"
                                        onChange={this.handleProvinceChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุจังหวัด
                                        </option>
                                        {this.state.array_province.map((data) => {
                                          return data.PROVINCE_ID ===
                                            this.state.ADDRESS_PROVINCY ? (
                                            <>
                                              <option value={data.PROVINCE_ID} selected>
                                                {data.PROVINCE_NAME_TH}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.PROVINCE_ID}>
                                                {data.PROVINCE_NAME_TH}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="ADDRESS_DISTRICT">
                                        อำเภอ/เขต <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="ADDRESS_DISTRICT"
                                        name="ADDRESS_DISTRICT"
                                        onChange={this.handleDistrictChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุอำเภอ
                                        </option>
                                        {this.state.array_district.map((data) => {
                                          return data.DISTRICT_ID ===
                                            this.state.ADDRESS_DISTRICT ? (
                                            <>
                                              <option value={data.DISTRICT_ID} selected>
                                                {data.DISTRICT_NAME_TH}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.DISTRICT_ID}>
                                                {data.DISTRICT_NAME_TH}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="SUBDISTRICT">
                                        ตำบล/แขวง <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="SUBDISTRICT"
                                        name="SUBDISTRICT"
                                        onChange={this.handleSubDistrictChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุตำบล
                                        </option>
                                        {this.state.array_sub_district.map((data) => {
                                          return data.SUB_DISTRICT_ID + "," + data.ZIPCODE ===
                                            this.state.SUBDISTRICT ? (
                                            <>
                                              <option
                                                value={data.SUB_DISTRICT_ID + "," + data.ZIPCODE}
                                                selected
                                              >
                                                {data.SUB_DISTRICT_NAME_TH}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option
                                                value={data.SUB_DISTRICT_ID + "," + data.ZIPCODE}
                                              >
                                                {data.SUB_DISTRICT_NAME_TH}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="FATHER_ADDRESS_ZIPCODE">
                                        รหัสไปรษณีย์
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="FATHER_ADDRESS_ZIPCODE"
                                        name="FATHER_ADDRESS_ZIPCODE"
                                        maxlength="5"
                                        value={this.state.FATHER_ADDRESS_ZIPCODE}
                                        disabled
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                </>
                              ) : (
                                <></>
                              )}
                            </MDBRow>

                            <hr width="100%" color="black" />
                            <MDBCardTitle className="mt-2 black-text">ข้อมูลมารดา</MDBCardTitle>
                            <MDBRow className="mt-2">
                              <MDBCol lg="2" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="MOTHER_STATUS_PARENT2">
                                    สถานภาพมารดา <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="MOTHER_STATUS_PARENT"
                                      id="MOTHER_STATUS_PARENT1"
                                      onClick={this.handleClick}
                                      value="0"
                                      checked={
                                        this.state.MOTHER_STATUS_PARENT === "0" ? true : false
                                      }
                                    />
                                    <label className="form-check-label" for="MOTHER_STATUS_PARENT1">
                                      ถึงแก่กรรม
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="MOTHER_STATUS_PARENT"
                                      id="MOTHER_STATUS_PARENT2"
                                      onClick={this.handleClick}
                                      value="1"
                                      checked={
                                        this.state.MOTHER_STATUS_PARENT === "1" ? true : false
                                      }
                                    />
                                    <label className="form-check-label" for="MOTHER_STATUS_PARENT2">
                                      มีชีวิต
                                    </label>
                                  </div>
                                </div>
                              </MDBCol>
                              {this.state.MOTHER_STATUS_PARENT === "1" ? (
                                <>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_CITIZENT_PARENT">
                                        เลขบัตรประชาชนมารดา <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="MOTHER_CITIZENT_PARENT"
                                        name="MOTHER_CITIZENT_PARENT"
                                        onChange={this.handleChange}
                                        value={this.state.MOTHER_CITIZENT_PARENT}
                                        maxLength="13"
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_PREFIX_PARENT">
                                        คำนำหน้ามารดา <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="MOTHER_PREFIX_PARENT"
                                        name="MOTHER_PREFIX_PARENT"
                                        value={this.state.MOTHER_PREFIX_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุคำนำหน้ามารดา
                                        </option>
                                        {this.state.array_prefix.map((data) => {
                                          return data.PREFIX_NAME_ID ===
                                            this.state.MOTHER_PREFIX_PARENT ? (
                                            <>
                                              <option value={data.PREFIX_NAME_ID} selected>
                                                {data.FULLNAME}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.PREFIX_NAME_ID}>
                                                {data.FULLNAME}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_FRISTNAME_PARENT">
                                        ชื่อภาษาไทยมารดา <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="MOTHER_FRISTNAME_PARENT"
                                        name="MOTHER_FRISTNAME_PARENT"
                                        value={this.state.MOTHER_FRISTNAME_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_MIDNAME_PARENT">
                                        ชื่อกลางภาษาไทยมารดา
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="MOTHER_MIDNAME_PARENT"
                                        name="MOTHER_MIDNAME_PARENT"
                                        value={this.state.MOTHER_MIDNAME_PARENT}
                                        onChange={this.handleChange}
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_LASTNAME_PARENT">
                                        นามสกุลภาษาไทยมารดา <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="MOTHER_LASTNAME_PARENT"
                                        name="MOTHER_LASTNAME_PARENT"
                                        value={this.state.MOTHER_LASTNAME_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_TELMOBILE_PARENT">
                                        เบอร์โทรศัพท์มือถือมารดา{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="tel"
                                        className="form-control"
                                        id="MOTHER_TELMOBILE_PARENT"
                                        name="MOTHER_TELMOBILE_PARENT"
                                        value={this.state.MOTHER_TELMOBILE_PARENT}
                                        onChange={this.handleChange}
                                        maxLength="10"
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_OCCUP_PARENT">
                                        อาชีพมารดา <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="MOTHER_OCCUP_PARENT"
                                        name="MOTHER_OCCUP_PARENT"
                                        value={this.state.MOTHER_OCCUP_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุอาชีพมารดา
                                        </option>
                                        {this.state.array_occup.map((data) => {
                                          return data.OCCUP_ID ===
                                            this.state.MOTHER_OCCUP_PARENT ? (
                                            <>
                                              <option value={data.OCCUP_ID} selected>
                                                {data.OCCUP_NAME}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.OCCUP_ID}>
                                                {data.OCCUP_NAME}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  {this.state.MOTHER_OCCUP_PARENT === "07" ? (
                                    <>
                                      <MDBCol lg="3" md="4" sm="12">
                                        <div className="form-outline mt-2">
                                          <label
                                            className="form-label"
                                            for="MOTHER_OCCUP_NAME_PARENT"
                                          >
                                            ระบุอาชีพมารดา <span className="text-danger"></span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="MOTHER_OCCUP_NAME_PARENT"
                                            name="MOTHER_OCCUP_NAME_PARENT"
                                            value={this.state.MOTHER_OCCUP_NAME_PARENT}
                                            onChange={this.handleChange}
                                            required
                                          />
                                        </div>
                                      </MDBCol>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_REVENUE_PARENT">
                                        รายได้มารดา <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="MOTHER_REVENUE_PARENT"
                                        name="MOTHER_REVENUE_PARENT"
                                        value={this.state.MOTHER_REVENUE_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุรายได้มารดา
                                        </option>
                                        {this.state.array_revenue.map((data) => {
                                          return data.REVENUE_ID ===
                                            this.state.MOTHER_REVENUE_PARENT ? (
                                            <>
                                              <option value={data.REVENUE_ID} selected>
                                                {data.REVENUE_NAME}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.REVENUE_ID}>
                                                {data.REVENUE_NAME}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_FACEBOOK">
                                        Facebook <span className="text-danger"></span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="MOTHER_FACEBOOK"
                                        name="MOTHER_FACEBOOK"
                                        value={this.state.MOTHER_FACEBOOK}
                                        onChange={this.handleChange}
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_ADDRESS">
                                        ชื่อหน่วยงาน/สถานทีทำงาน{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="MOTHER_ADDRESS"
                                        name="MOTHER_ADDRESS"
                                        value={this.state.MOTHER_ADDRESS}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_ADDRESS_HOME">
                                        เลขที่ <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="MOTHER_ADDRESS_HOME"
                                        name="MOTHER_ADDRESS_HOME"
                                        value={this.state.MOTHER_ADDRESS_HOME}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_ADDRESS_MOO">
                                        หมู่ที่ <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="MOTHER_ADDRESS_MOO"
                                        name="MOTHER_ADDRESS_MOO"
                                        value={this.state.MOTHER_ADDRESS_MOO}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_ADDRESS_SOI">
                                        ซอย <span className="text-danger">หากไม่มีให้ใส่ -</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="MOTHER_ADDRESS_SOI"
                                        name="MOTHER_ADDRESS_SOI"
                                        value={this.state.MOTHER_ADDRESS_SOI}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_ADDRESS_STREET">
                                        ถนน <span className="text-danger">หากไม่มีให้ใส่ -</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="MOTHER_ADDRESS_STREET"
                                        name="MOTHER_ADDRESS_STREET"
                                        value={this.state.MOTHER_ADDRESS_STREET}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="ADDRESS_PROVINCY1">
                                        จังหวัด <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="ADDRESS_PROVINCY1"
                                        name="ADDRESS_PROVINCY1"
                                        onChange={this.handleProvince1Change}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุจังหวัด
                                        </option>
                                        {this.state.array_province.map((data) => {
                                          return data.PROVINCE_ID ===
                                            this.state.ADDRESS_PROVINCY1 ? (
                                            <>
                                              <option value={data.PROVINCE_ID} selected>
                                                {data.PROVINCE_NAME_TH}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.PROVINCE_ID}>
                                                {data.PROVINCE_NAME_TH}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="ADDRESS_DISTRICT1">
                                        อำเภอ/เขต <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="ADDRESS_DISTRICT1"
                                        name="ADDRESS_DISTRICT1"
                                        onChange={this.handleDistrict1Change}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุอำเภอ
                                        </option>
                                        {this.state.array_district1.map((data) => {
                                          return data.DISTRICT_ID ===
                                            this.state.ADDRESS_DISTRICT1 ? (
                                            <>
                                              <option value={data.DISTRICT_ID} selected>
                                                {data.DISTRICT_NAME_TH}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.DISTRICT_ID}>
                                                {data.DISTRICT_NAME_TH}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="SUBDISTRICT1">
                                        ตำบล/แขวง <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="SUBDISTRICT1"
                                        name="SUBDISTRICT1"
                                        onChange={this.handleSubDistrict1Change}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุตำบล
                                        </option>
                                        {this.state.array_sub_district1.map((data) => {
                                          return data.SUB_DISTRICT_ID + "," + data.ZIPCODE ===
                                            this.state.SUBDISTRICT1 ? (
                                            <>
                                              <option
                                                value={data.SUB_DISTRICT_ID + "," + data.ZIPCODE}
                                                selected
                                              >
                                                {data.SUB_DISTRICT_NAME_TH}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option
                                                value={data.SUB_DISTRICT_ID + "," + data.ZIPCODE}
                                              >
                                                {data.SUB_DISTRICT_NAME_TH}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="MOTHER_ADDRESS_ZIPCODE">
                                        รหัสไปรษณีย์
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="MOTHER_ADDRESS_ZIPCODE"
                                        name="MOTHER_ADDRESS_ZIPCODE"
                                        maxlength="5"
                                        value={this.state.MOTHER_ADDRESS_ZIPCODE}
                                        disabled
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                </>
                              ) : (
                                <></>
                              )}
                            </MDBRow>

                            <MDBRow className="mt-2">
                              <MDBCol lg="12" md="12" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="STATUS_PARENT">
                                    สถานภาพบิดา-มารดา <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="STATUS_PARENT"
                                    name="STATUS_PARENT"
                                    value={this.state.STATUS_PARENT}
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุสถานภาพบิดา-มารดา
                                    </option>
                                    {this.state.array_parentshow.map((data) => {
                                      return data.PAR_STATUS_ID === this.state.STATUS_PARENT ? (
                                        <>
                                          <option value={data.PAR_STATUS_ID} selected>
                                            {data.PAR_STATUS_NAME}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.PAR_STATUS_ID}>
                                            {data.PAR_STATUS_NAME}
                                          </option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                            </MDBRow>

                            <hr width="100%" color="black" />
                            <MDBCardTitle className="mt-2 black-text">
                              ข้อมูลผู้ปกครอง/บุคคลที่สามารถติดต่อได้ในกรณีฉุกเฉิน
                            </MDBCardTitle>
                            <MDBRow className="mt-2">
                              <MDBCol lg="2" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label">
                                    ใช้ข้อมูล <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="PARENTSTATUS"
                                      id="PARENTSTATUS1"
                                      onClick={this.handleClick}
                                      value="1"
                                      disabled={
                                        this.state.FATHER_STATUS_PARENT === "0" ? true : false
                                      }
                                      checked={this.state.PARENTSTATUS === "1" ? true : false}
                                    />
                                    <label className="form-check-label" for="PARENTSTATUS1">
                                      บิดา
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="PARENTSTATUS"
                                      id="PARENTSTATUS2"
                                      onClick={this.handleClick}
                                      value="2"
                                      disabled={
                                        this.state.MOTHER_STATUS_PARENT === "0" ? true : false
                                      }
                                      checked={this.state.PARENTSTATUS === "2" ? true : false}
                                    />
                                    <label className="form-check-label" for="PARENTSTATUS2">
                                      มารดา
                                    </label>
                                  </div>
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="PARENTSTATUS"
                                      id="PARENTSTATUS3"
                                      onClick={this.handleClick}
                                      value="3"
                                      checked={this.state.PARENTSTATUS === "3" ? true : false}
                                    />
                                    <label className="form-check-label" for="PARENTSTATUS3">
                                      บุคคลอื่นๆ
                                    </label>
                                  </div>
                                  {/* <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="PARENT_STATUS_PARENT" id="PARENT_STATUS_PARENT1" onClick={this.handleClick} value="0" checked={this.state.PARENT_STATUS_PARENT === "0" ? true:false}/>
                                                                    <label className="form-check-label" for="PARENT_STATUS_PARENT1">ถึงแก่กรรม</label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input className="form-check-input" type="radio" name="PARENT_STATUS_PARENT" id="PARENT_STATUS_PARENT2" onClick={this.handleClick} value="1" checked={this.state.PARENT_STATUS_PARENT === "1" ? true:false} />
                                                                    <label className="form-check-label" for="PARENT_STATUS_PARENT2">มีชีวิต</label>
                                                                </div> */}
                                </div>
                              </MDBCol>
                              {this.state.PARENTSTATUS === "3" ? (
                                <>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_OTHER_PARENT">
                                        ความสัมพันธ์{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="PARENT_OTHER_PARENT"
                                        name="PARENT_OTHER_PARENT"
                                        onChange={this.handleChange}
                                        value={this.state.PARENT_OTHER_PARENT}
                                        // maxLength="13"
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_CITIZENT_PARENT">
                                        เลขบัตรประชาชนผู้ปกครอง{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="PARENT_CITIZENT_PARENT"
                                        name="PARENT_CITIZENT_PARENT"
                                        onChange={this.handleChange}
                                        value={this.state.PARENT_CITIZENT_PARENT}
                                        maxLength="13"
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_PREFIX_PARENT">
                                        คำนำหน้าผู้ปกครอง <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="PARENT_PREFIX_PARENT"
                                        name="PARENT_PREFIX_PARENT"
                                        value={this.state.PARENT_PREFIX_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุคำนำหน้าผู้ปกครอง
                                        </option>
                                        {this.state.array_prefix.map((data) => {
                                          return data.PREFIX_NAME_ID ===
                                            this.state.PARENT_PREFIX_PARENT ? (
                                            <>
                                              <option value={data.PREFIX_NAME_ID} selected>
                                                {data.FULLNAME}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.PREFIX_NAME_ID}>
                                                {data.FULLNAME}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_FRISTNAME_PARENT">
                                        ชื่อภาษาไทยผู้ปกครอง <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="PARENT_FRISTNAME_PARENT"
                                        name="PARENT_FRISTNAME_PARENT"
                                        value={this.state.PARENT_FRISTNAME_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_MIDNAME_PARENT">
                                        ชื่อกลางภาษาไทยผู้ปกครอง
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="PARENT_MIDNAME_PARENT"
                                        name="PARENT_MIDNAME_PARENT"
                                        value={this.state.PARENT_MIDNAME_PARENT}
                                        onChange={this.handleChange}
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_LASTNAME_PARENT">
                                        นามสกุลภาษาไทยผู้ปกครอง{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="PARENT_LASTNAME_PARENT"
                                        name="PARENT_LASTNAME_PARENT"
                                        value={this.state.PARENT_LASTNAME_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_TELMOBILE_PARENT">
                                        เบอร์โทรศัพท์มือถือผู้ปกครอง{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="tel"
                                        className="form-control"
                                        id="PARENT_TELMOBILE_PARENT"
                                        name="PARENT_TELMOBILE_PARENT"
                                        value={this.state.PARENT_TELMOBILE_PARENT}
                                        onChange={this.handleChange}
                                        maxLength="10"
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_OCCUP_PARENT">
                                        อาชีพผู้ปกครอง <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="PARENT_OCCUP_PARENT"
                                        name="PARENT_OCCUP_PARENT"
                                        value={this.state.PARENT_OCCUP_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุอาชีพผู้ปกครอง
                                        </option>
                                        {this.state.array_occup.map((data) => {
                                          return data.OCCUP_ID ===
                                            this.state.PARENT_OCCUP_PARENT ? (
                                            <>
                                              <option value={data.OCCUP_ID} selected>
                                                {data.OCCUP_NAME}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.OCCUP_ID}>
                                                {data.OCCUP_NAME}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  {this.state.PARENT_OCCUP_PARENT === "07" ? (
                                    <>
                                      <MDBCol lg="3" md="4" sm="12">
                                        <div className="form-outline mt-2">
                                          <label
                                            className="form-label"
                                            for="PARENT_OCCUP_NAME_PARENT"
                                          >
                                            ระบุอาชีพผู้ปกครอง
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="PARENT_OCCUP_NAME_PARENT"
                                            name="PARENT_OCCUP_NAME_PARENT"
                                            value={this.state.PARENT_OCCUP_NAME_PARENT}
                                            onChange={this.handleChange}
                                            required
                                          />
                                        </div>
                                      </MDBCol>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_REVENUE_PARENT">
                                        รายได้ผู้ปกครอง <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="PARENT_REVENUE_PARENT"
                                        name="PARENT_REVENUE_PARENT"
                                        value={this.state.PARENT_REVENUE_PARENT}
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุรายได้ผู้ปกครอง
                                        </option>
                                        {this.state.array_revenue.map((data) => {
                                          return data.REVENUE_ID ===
                                            this.state.PARENT_REVENUE_PARENT ? (
                                            <>
                                              <option value={data.REVENUE_ID} selected>
                                                {data.REVENUE_NAME}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.REVENUE_ID}>
                                                {data.REVENUE_NAME}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_FACEBOOK">
                                        Facebook <span className="text-danger"></span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="PARENT_FACEBOOK"
                                        name="PARENT_FACEBOOK"
                                        value={this.state.PARENT_FACEBOOK}
                                        onChange={this.handleChange}
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_ADDRESS">
                                        ชื่อหน่วยงาน/สถานทีทำงาน{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="PARENT_ADDRESS"
                                        name="PARENT_ADDRESS"
                                        value={this.state.PARENT_ADDRESS}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_ADDRESS_HOME">
                                        เลขที่ <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="PARENT_ADDRESS_HOME"
                                        name="PARENT_ADDRESS_HOME"
                                        value={this.state.PARENT_ADDRESS_HOME}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_ADDRESS_MOO">
                                        หมู่ที่ <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="PARENT_ADDRESS_MOO"
                                        name="PARENT_ADDRESS_MOO"
                                        value={this.state.PARENT_ADDRESS_MOO}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_ADDRESS_SOI">
                                        ซอย <span className="text-danger">หากไม่มีให้ใส่ -</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="PARENT_ADDRESS_SOI"
                                        name="PARENT_ADDRESS_SOI"
                                        value={this.state.PARENT_ADDRESS_SOI}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="2" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_ADDRESS_STREET">
                                        ถนน <span className="text-danger">หากไม่มีให้ใส่ -</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="PARENT_ADDRESS_STREET"
                                        name="PARENT_ADDRESS_STREET"
                                        value={this.state.PARENT_ADDRESS_STREET}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="ADDRESS_PROVINCY2">
                                        จังหวัด <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="ADDRESS_PROVINCY2"
                                        name="ADDRESS_PROVINCY2"
                                        onChange={this.handleProvince2Change}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุจังหวัด
                                        </option>
                                        {this.state.array_province.map((data) => {
                                          return data.PROVINCE_ID ===
                                            this.state.ADDRESS_PROVINCY2 ? (
                                            <>
                                              <option value={data.PROVINCE_ID} selected>
                                                {data.PROVINCE_NAME_TH}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.PROVINCE_ID}>
                                                {data.PROVINCE_NAME_TH}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="ADDRESS_DISTRICT2">
                                        อำเภอ/เขต <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="ADDRESS_DISTRICT2"
                                        name="ADDRESS_DISTRICT2"
                                        onChange={this.handleDistrict2Change}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุอำเภอ
                                        </option>
                                        {this.state.array_district2.map((data) => {
                                          return data.DISTRICT_ID ===
                                            this.state.ADDRESS_DISTRICT2 ? (
                                            <>
                                              <option value={data.DISTRICT_ID} selected>
                                                {data.DISTRICT_NAME_TH}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.DISTRICT_ID}>
                                                {data.DISTRICT_NAME_TH}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="SUBDISTRICT2">
                                        ตำบล/แขวง <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="SUBDISTRICT2"
                                        name="SUBDISTRICT2"
                                        onChange={this.handleSubDistrict2Change}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุตำบล
                                        </option>
                                        {this.state.array_sub_district2.map((data) => {
                                          return data.SUB_DISTRICT_ID + "," + data.ZIPCODE ===
                                            this.state.SUBDISTRICT2 ? (
                                            <>
                                              <option
                                                value={data.SUB_DISTRICT_ID + "," + data.ZIPCODE}
                                                selected
                                              >
                                                {data.SUB_DISTRICT_NAME_TH}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option
                                                value={data.SUB_DISTRICT_ID + "," + data.ZIPCODE}
                                              >
                                                {data.SUB_DISTRICT_NAME_TH}
                                              </option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="PARENT_ADDRESS_ZIPCODE">
                                        รหัสไปรษณีย์
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="PARENT_ADDRESS_ZIPCODE"
                                        name="PARENT_ADDRESS_ZIPCODE"
                                        maxlength="5"
                                        value={this.state.PARENT_ADDRESS_ZIPCODE}
                                        disabled
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                </>
                              ) : (
                                <></>
                              )}
                            </MDBRow>
                          </MDBCardText>
                        </MDBCol>
                      </MDBRow>

                      {this.state.FATHER_STATUS_PARENT === "0" &&
                      this.state.MOTHER_STATUS_PARENT === "0" ? (
                        <>
                          {this.state.STATUS_PARENT &&
                          this.state.PARENTSTATUS &&
                          this.state.PARENT_CITIZENT_PARENT &&
                          this.state.PARENT_PREFIX_PARENT &&
                          this.state.PARENT_FRISTNAME_PARENT &&
                          this.state.PARENT_LASTNAME_PARENT &&
                          this.state.PARENT_TELMOBILE_PARENT &&
                          this.state.PARENT_OCCUP_PARENT &&
                          this.state.PARENT_REVENUE_PARENT &&
                          this.state.PARENT_ADDRESS &&
                          this.state.PARENT_ADDRESS_HOME &&
                          this.state.PARENT_ADDRESS_MOO &&
                          this.state.PARENT_ADDRESS_SOI &&
                          this.state.PARENT_ADDRESS_STREET &&
                          this.state.ADDRESS_PROVINCY2 &&
                          this.state.ADDRESS_DISTRICT2 &&
                          this.state.ADDRESS_SUBDISTRICT2 &&
                          this.state.PARENT_ADDRESS_ZIPCODE ? (
                            <>
                              <button
                                type="submit"
                                className="btn btn-primary btn-rounded btn-md mt-2"
                              >
                                บันทึกข้อมูล
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                type="submit"
                                className="btn btn-primary btn-rounded btn-md mt-2"
                                disabled
                              >
                                บันทึกข้อมูล
                              </button>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {this.state.FATHER_STATUS_PARENT === "1" &&
                          this.state.MOTHER_STATUS_PARENT === "1" ? (
                            <>
                              {this.state.PARENTSTATUS === "1" ||
                              this.state.PARENTSTATUS === "2" ? (
                                <>
                                  {this.state.FATHER_CITIZENT_PARENT &&
                                  this.state.FATHER_PREFIX_PARENT &&
                                  this.state.FATHER_FRISTNAME_PARENT &&
                                  this.state.FATHER_LASTNAME_PARENT &&
                                  this.state.FATHER_TELMOBILE_PARENT &&
                                  this.state.FATHER_OCCUP_PARENT &&
                                  this.state.FATHER_REVENUE_PARENT &&
                                  this.state.FATHER_ADDRESS &&
                                  this.state.FATHER_ADDRESS_HOME &&
                                  this.state.FATHER_ADDRESS_MOO &&
                                  this.state.FATHER_ADDRESS_SOI &&
                                  this.state.FATHER_ADDRESS_STREET &&
                                  this.state.ADDRESS_PROVINCY &&
                                  this.state.ADDRESS_DISTRICT &&
                                  this.state.ADDRESS_SUBDISTRICT &&
                                  this.state.FATHER_ADDRESS_ZIPCODE &&
                                  this.state.MOTHER_CITIZENT_PARENT &&
                                  this.state.MOTHER_PREFIX_PARENT &&
                                  this.state.MOTHER_FRISTNAME_PARENT &&
                                  this.state.MOTHER_LASTNAME_PARENT &&
                                  this.state.MOTHER_TELMOBILE_PARENT &&
                                  this.state.MOTHER_OCCUP_PARENT &&
                                  this.state.MOTHER_REVENUE_PARENT &&
                                  this.state.MOTHER_ADDRESS &&
                                  this.state.MOTHER_ADDRESS_HOME &&
                                  this.state.MOTHER_ADDRESS_MOO &&
                                  this.state.MOTHER_ADDRESS_SOI &&
                                  this.state.MOTHER_ADDRESS_STREET &&
                                  this.state.ADDRESS_PROVINCY1 &&
                                  this.state.ADDRESS_DISTRICT1 &&
                                  this.state.ADDRESS_SUBDISTRICT1 &&
                                  this.state.MOTHER_ADDRESS_ZIPCODE &&
                                  this.state.STATUS_PARENT ? (
                                    <>
                                      <button
                                        type="submit"
                                        className="btn btn-primary btn-rounded btn-md mt-2"
                                      >
                                        บันทึกข้อมูล
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        type="submit"
                                        className="btn btn-primary btn-rounded btn-md mt-2"
                                        disabled
                                      >
                                        บันทึกข้อมูล
                                      </button>
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {this.state.FATHER_CITIZENT_PARENT &&
                                  this.state.FATHER_PREFIX_PARENT &&
                                  this.state.FATHER_FRISTNAME_PARENT &&
                                  this.state.FATHER_LASTNAME_PARENT &&
                                  this.state.FATHER_TELMOBILE_PARENT &&
                                  this.state.FATHER_OCCUP_PARENT &&
                                  this.state.FATHER_REVENUE_PARENT &&
                                  this.state.FATHER_ADDRESS &&
                                  this.state.FATHER_ADDRESS_HOME &&
                                  this.state.FATHER_ADDRESS_MOO &&
                                  this.state.FATHER_ADDRESS_SOI &&
                                  this.state.FATHER_ADDRESS_STREET &&
                                  this.state.ADDRESS_PROVINCY &&
                                  this.state.ADDRESS_DISTRICT &&
                                  this.state.ADDRESS_SUBDISTRICT &&
                                  this.state.FATHER_ADDRESS_ZIPCODE &&
                                  this.state.MOTHER_CITIZENT_PARENT &&
                                  this.state.MOTHER_PREFIX_PARENT &&
                                  this.state.MOTHER_FRISTNAME_PARENT &&
                                  this.state.MOTHER_LASTNAME_PARENT &&
                                  this.state.MOTHER_TELMOBILE_PARENT &&
                                  this.state.MOTHER_OCCUP_PARENT &&
                                  this.state.MOTHER_REVENUE_PARENT &&
                                  this.state.MOTHER_ADDRESS &&
                                  this.state.MOTHER_ADDRESS_HOME &&
                                  this.state.MOTHER_ADDRESS_MOO &&
                                  this.state.MOTHER_ADDRESS_SOI &&
                                  this.state.MOTHER_ADDRESS_STREET &&
                                  this.state.ADDRESS_PROVINCY1 &&
                                  this.state.ADDRESS_DISTRICT1 &&
                                  this.state.ADDRESS_SUBDISTRICT1 &&
                                  this.state.MOTHER_ADDRESS_ZIPCODE &&
                                  this.state.STATUS_PARENT &&
                                  this.state.PARENT_CITIZENT_PARENT &&
                                  this.state.PARENT_PREFIX_PARENT &&
                                  this.state.PARENT_FRISTNAME_PARENT &&
                                  this.state.PARENT_LASTNAME_PARENT &&
                                  this.state.PARENT_TELMOBILE_PARENT &&
                                  this.state.PARENT_OCCUP_PARENT &&
                                  this.state.PARENT_REVENUE_PARENT &&
                                  this.state.PARENT_ADDRESS &&
                                  this.state.PARENT_ADDRESS_HOME &&
                                  this.state.PARENT_ADDRESS_MOO &&
                                  this.state.PARENT_ADDRESS_SOI &&
                                  this.state.PARENT_ADDRESS_STREET &&
                                  this.state.ADDRESS_PROVINCY2 &&
                                  this.state.ADDRESS_DISTRICT2 &&
                                  this.state.ADDRESS_SUBDISTRICT2 &&
                                  this.state.PARENT_ADDRESS_ZIPCODE ? (
                                    <>
                                      <button
                                        type="submit"
                                        className="btn btn-primary btn-rounded btn-md mt-2"
                                      >
                                        บันทึกข้อมูล
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        type="submit"
                                        className="btn btn-primary btn-rounded btn-md mt-2"
                                        disabled
                                      >
                                        บันทึกข้อมูล
                                      </button>
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {this.state.FATHER_STATUS_PARENT === "1" &&
                              this.state.MOTHER_STATUS_PARENT === "0" ? (
                                <>
                                  {this.state.PARENTSTATUS === "1" ? (
                                    <>
                                      {this.state.FATHER_CITIZENT_PARENT &&
                                      this.state.FATHER_PREFIX_PARENT &&
                                      this.state.FATHER_FRISTNAME_PARENT &&
                                      this.state.FATHER_LASTNAME_PARENT &&
                                      this.state.FATHER_TELMOBILE_PARENT &&
                                      this.state.FATHER_OCCUP_PARENT &&
                                      this.state.FATHER_REVENUE_PARENT &&
                                      this.state.FATHER_ADDRESS &&
                                      this.state.FATHER_ADDRESS_HOME &&
                                      this.state.FATHER_ADDRESS_MOO &&
                                      this.state.FATHER_ADDRESS_SOI &&
                                      this.state.FATHER_ADDRESS_STREET &&
                                      this.state.ADDRESS_PROVINCY &&
                                      this.state.ADDRESS_DISTRICT &&
                                      this.state.ADDRESS_SUBDISTRICT &&
                                      this.state.FATHER_ADDRESS_ZIPCODE &&
                                      this.state.STATUS_PARENT ? (
                                        <>
                                          <button
                                            type="submit"
                                            className="btn btn-primary btn-rounded btn-md mt-2"
                                          >
                                            บันทึกข้อมูล
                                          </button>
                                        </>
                                      ) : (
                                        <>
                                          <button
                                            type="submit"
                                            className="btn btn-primary btn-rounded btn-md mt-2"
                                            disabled
                                          >
                                            บันทึกข้อมูล
                                          </button>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {this.state.FATHER_CITIZENT_PARENT &&
                                      this.state.FATHER_PREFIX_PARENT &&
                                      this.state.FATHER_FRISTNAME_PARENT &&
                                      this.state.FATHER_LASTNAME_PARENT &&
                                      this.state.FATHER_TELMOBILE_PARENT &&
                                      this.state.FATHER_OCCUP_PARENT &&
                                      this.state.FATHER_REVENUE_PARENT &&
                                      this.state.FATHER_ADDRESS &&
                                      this.state.FATHER_ADDRESS_HOME &&
                                      this.state.FATHER_ADDRESS_MOO &&
                                      this.state.FATHER_ADDRESS_SOI &&
                                      this.state.FATHER_ADDRESS_STREET &&
                                      this.state.ADDRESS_PROVINCY &&
                                      this.state.ADDRESS_DISTRICT &&
                                      this.state.ADDRESS_SUBDISTRICT &&
                                      this.state.FATHER_ADDRESS_ZIPCODE &&
                                      this.state.STATUS_PARENT &&
                                      this.state.PARENT_CITIZENT_PARENT &&
                                      this.state.PARENT_PREFIX_PARENT &&
                                      this.state.PARENT_FRISTNAME_PARENT &&
                                      this.state.PARENT_LASTNAME_PARENT &&
                                      this.state.PARENT_TELMOBILE_PARENT &&
                                      this.state.PARENT_OCCUP_PARENT &&
                                      this.state.PARENT_REVENUE_PARENT &&
                                      this.state.PARENT_ADDRESS &&
                                      this.state.PARENT_ADDRESS_HOME &&
                                      this.state.PARENT_ADDRESS_MOO &&
                                      this.state.PARENT_ADDRESS_SOI &&
                                      this.state.PARENT_ADDRESS_STREET &&
                                      this.state.ADDRESS_PROVINCY2 &&
                                      this.state.ADDRESS_DISTRICT2 &&
                                      this.state.ADDRESS_SUBDISTRICT2 &&
                                      this.state.PARENT_ADDRESS_ZIPCODE ? (
                                        <>
                                          <button
                                            type="submit"
                                            className="btn btn-primary btn-rounded btn-md mt-2"
                                          >
                                            บันทึกข้อมูล
                                          </button>
                                        </>
                                      ) : (
                                        <>
                                          <button
                                            type="submit"
                                            className="btn btn-primary btn-rounded btn-md mt-2"
                                            disabled
                                          >
                                            บันทึกข้อมูล
                                          </button>
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {this.state.FATHER_STATUS_PARENT === "0" &&
                                  this.state.MOTHER_STATUS_PARENT === "1" ? (
                                    <>
                                      {this.state.PARENTSTATUS === "2" ? (
                                        <>
                                          {this.state.MOTHER_CITIZENT_PARENT &&
                                          this.state.MOTHER_PREFIX_PARENT &&
                                          this.state.MOTHER_FRISTNAME_PARENT &&
                                          this.state.MOTHER_LASTNAME_PARENT &&
                                          this.state.MOTHER_TELMOBILE_PARENT &&
                                          this.state.MOTHER_OCCUP_PARENT &&
                                          this.state.MOTHER_REVENUE_PARENT &&
                                          this.state.MOTHER_ADDRESS &&
                                          this.state.MOTHER_ADDRESS_HOME &&
                                          this.state.MOTHER_ADDRESS_MOO &&
                                          this.state.MOTHER_ADDRESS_SOI &&
                                          this.state.MOTHER_ADDRESS_STREET &&
                                          this.state.ADDRESS_PROVINCY1 &&
                                          this.state.ADDRESS_DISTRICT1 &&
                                          this.state.ADDRESS_SUBDISTRICT1 &&
                                          this.state.MOTHER_ADDRESS_ZIPCODE &&
                                          this.state.STATUS_PARENT ? (
                                            <>
                                              <button
                                                type="submit"
                                                className="btn btn-primary btn-rounded btn-md mt-2"
                                              >
                                                บันทึกข้อมูล
                                              </button>
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                type="submit"
                                                className="btn btn-primary btn-rounded btn-md mt-2"
                                                disabled
                                              >
                                                บันทึกข้อมูล
                                              </button>
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {this.state.MOTHER_CITIZENT_PARENT &&
                                          this.state.MOTHER_PREFIX_PARENT &&
                                          this.state.MOTHER_FRISTNAME_PARENT &&
                                          this.state.MOTHER_LASTNAME_PARENT &&
                                          this.state.MOTHER_TELMOBILE_PARENT &&
                                          this.state.MOTHER_OCCUP_PARENT &&
                                          this.state.MOTHER_REVENUE_PARENT &&
                                          this.state.MOTHER_ADDRESS &&
                                          this.state.MOTHER_ADDRESS_HOME &&
                                          this.state.MOTHER_ADDRESS_MOO &&
                                          this.state.MOTHER_ADDRESS_SOI &&
                                          this.state.MOTHER_ADDRESS_STREET &&
                                          this.state.ADDRESS_PROVINCY1 &&
                                          this.state.ADDRESS_DISTRICT1 &&
                                          this.state.ADDRESS_SUBDISTRICT1 &&
                                          this.state.MOTHER_ADDRESS_ZIPCODE &&
                                          this.state.STATUS_PARENT &&
                                          this.state.PARENT_CITIZENT_PARENT &&
                                          this.state.PARENT_PREFIX_PARENT &&
                                          this.state.PARENT_FRISTNAME_PARENT &&
                                          this.state.PARENT_LASTNAME_PARENT &&
                                          this.state.PARENT_TELMOBILE_PARENT &&
                                          this.state.PARENT_OCCUP_PARENT &&
                                          this.state.PARENT_REVENUE_PARENT &&
                                          this.state.PARENT_ADDRESS &&
                                          this.state.PARENT_ADDRESS_HOME &&
                                          this.state.PARENT_ADDRESS_MOO &&
                                          this.state.PARENT_ADDRESS_SOI &&
                                          this.state.PARENT_ADDRESS_STREET &&
                                          this.state.ADDRESS_PROVINCY2 &&
                                          this.state.ADDRESS_DISTRICT2 &&
                                          this.state.ADDRESS_SUBDISTRICT2 &&
                                          this.state.PARENT_ADDRESS_ZIPCODE ? (
                                            <>
                                              <button
                                                type="submit"
                                                className="btn btn-primary btn-rounded btn-md mt-2"
                                              >
                                                บันทึกข้อมูล
                                              </button>
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                type="submit"
                                                className="btn btn-primary btn-rounded btn-md mt-2"
                                                disabled
                                              >
                                                บันทึกข้อมูล
                                              </button>
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </MDBContainer>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol lg="1" md="0" sm="0"></MDBCol>
            </MDBRow>
          </form>
        </MDBContainer>
      </>
    );
  }
}
